import React, { FunctionComponent } from "react";
import { DialogContent } from "@mui/material";
import { Login } from "../../pages/Login";
import { PiperDialog } from "../PiperDialog";

export const LoginAgainDialog: FunctionComponent<ILengthTextFieldProps> = ({
  isOpen,
  setIsOpen,
  closeOnTouch,
  loginCallback
}) => {
  return (
    <PiperDialog
      maxWidth={"md"}
      open={isOpen}
      onClose={() => {
        if (closeOnTouch ?? true) {
          setIsOpen(false);
        }
      }}
      PaperProps={{ sx: { borderRadius: "20px !important" } }}
    >
      <DialogContent style={{ padding: 0, overflow: "hidden", minWidth: 480 }}>
        <Login isMinimalist={true} loginCallback={loginCallback} />
      </DialogContent>
    </PiperDialog>
  );
};

export interface ILengthTextFieldProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  closeOnTouch?: boolean;
  loginCallback: () => void;
}
